export default __webpack_public_path__ + "static/media/telegram.5a75c7ec.svg";